import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";

const initialState = {
  bsfmData: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  createBsfm: {},
  isSuccessCreateBsfm: false,
  isErrorCreateBsfm: false,
  isErrorMessageCreateBsfm: "",
  deleteBsfm: {},
  isSuccessDeleteBsfm: false,
  isErrorDeleteBsfm: false,
  isErrorMessageDeleteBsfm: "",
  editBsfm: {},
  isSuccessEditBsfm: false,
  isErrorEditBsfm: false,
  isErrorMessageEditBsfm: "",
  isFetchingSingleBsfm: false,
  singleBsfmData: {},
  isSuccessSingleBsfm: false,
  isErrorSingleBsfm: false,
  isErrorMessageSingleBsfm: "",
  isFetchingSMS: false,
  isSuccessSmsIdentify: false,
  updateApplyFirewallData: [],
  isFetchingFirewall: false,
  isSuccessFirewall: false,
  isErrorFirewall: false,
  countryOperatorMap: {},
  isFetchingCountryOperatorMap: false,
};

export const getBsfmData = createAsyncThunk(
  "bsfm/get-bsfm-data",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      let url = `/firewall/list/profiles${udata || ""}`;
      

      const { data, status } = await axios.get(url, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      
      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("getBsfmData Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const createBsfmData = createAsyncThunk(
  "bsfm/create-bsfm",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.post("/firewall/save", udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
     

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("createBsfmData Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const deleteBsfmData = createAsyncThunk(
  "bsfm/delete-profile",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;

      const { data, status } = await axios.delete(
        `/firewall/delete?profilename=${udata}`,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
     

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("deleteBsfmData Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const editBsfmData = createAsyncThunk(
  "bsfm/update-template",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(`/firewall/update`, udata, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
     

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("editBsfmData Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getSingleBsfmData = createAsyncThunk(
  "bsfm/get-single",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        "/firewall/profile?id=" + udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
    

      if (status.toString().startsWith("2")) {
        return { ...data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("getSingleBsfmData Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const changeBsfmProfileFlag = createAsyncThunk(
  "bsfm/change-flag",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.put(
        "/firewall/update-flag?flag=" + udata,
        {},
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
     

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("changeBsfmProfileFlag Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getPreBsfmInformation = createAsyncThunk(
  "bsfm/get-pre-information",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        "/firewall/profile/pre-information",
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("getPreBsfmInformation Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getCountryOperatorMap = createAsyncThunk(
  "bsfm/get-country-operator-map",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const { data, status } = await axios.get(
        "/network/countries-operator-map",
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
     

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("getCountryOperatorMap Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const updateApplyFirewall = createAsyncThunk(
  "bsfm/update/firewall",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      const tokenStr = auth.user.accessToken;

      const { data, status } = await axios.put(
        "/firewall/update/priority",
        udata,
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );
      

      if (status.toString().startsWith("2")) {
        return { data, status };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      console.error("updateApplyFirewall Error:", err);
      if (!err.response) {
        throw err;
      }
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const bsfmSlice = createSlice({
  name: "bsfm",
  initialState,
  reducers: {
    clearStateBsfm: (state) => {
      state.bsfmData = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
    },
    clearStateCreateBsfm: (state) => {
      state.createBsfm = {};
      state.isFetching = false;
      state.isSuccessCreateBsfm = false;
      state.isErrorCreateBsfm = false;
      state.isErrorMessageCreateBsfm = "";
    },
    clearStateDeleteBsfm: (state) => {
      state.deleteBsfm = {};
      state.isFetching = false;
      state.isSuccessDeleteBsfm = false;
      state.isErrorDeleteBsfm = false;
      state.isErrorMessageDeleteBsfm = "";
    },
    clearStateEditBsfm: (state) => {
      state.editBsfm = {};
      state.isFetching = false;
      state.isSuccessEditBsfm = false;
      state.isErrorEditBsfm = false;
      state.isErrorMessageEditBsfm = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBsfmData.fulfilled, (state, action) => {
        const responseData = action.payload.data;
        state.bsfmData = Array.isArray(responseData)
          ? responseData
          : responseData?.data || [];
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getBsfmData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getBsfmData.rejected, (state, action) => {
        console.error("getBsfmData.rejected payload:", action.payload);
        state.bsfmData = [];
        state.isFetching = false;
        state.isError = true;
        state.errorMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(createBsfmData.fulfilled, (state, action) => {
        state.createBsfm = action.payload;
        state.isFetching = false;
        state.isSuccessCreateBsfm = true;
      })
      .addCase(createBsfmData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createBsfmData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorCreateBsfm = true;
        state.isErrorMessageCreateBsfm = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(deleteBsfmData.fulfilled, (state, action) => {
        state.deleteBsfm = action.payload;
        state.isFetching = false;
        state.isSuccessDeleteBsfm = true;
        if (state.bsfmData.length === 1) state.bsfmData = [];
      })
      .addCase(deleteBsfmData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(deleteBsfmData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorDeleteBsfm = true;
        state.isErrorMessageDeleteBsfm = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(editBsfmData.fulfilled, (state, action) => {
        state.editBsfm = action.payload;
        state.isFetching = false;
        state.isSuccessEditBsfm = true;
      })
      .addCase(editBsfmData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(editBsfmData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorEditBsfm = true;
        state.isErrorMessageEditBsfm = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(getSingleBsfmData.fulfilled, (state, action) => {
        state.singleBsfmData = action.payload;
        state.isFetchingSingleBsfm = false;
        state.isSuccessSingleBsfm = true;
      })
      .addCase(getSingleBsfmData.pending, (state) => {
        state.isFetchingSingleBsfm = true;
      })
      .addCase(getSingleBsfmData.rejected, (state, action) => {
        state.isFetchingSingleBsfm = false;
        state.isErrorSingleBsfm = true;
        state.isErrorMessageSingleBsfm = action.payload
          ? action.payload.message
          : "Internal error";
      })
      .addCase(changeBsfmProfileFlag.fulfilled, (state, action) => {
        state.smsIdentify = action.payload;
        state.isFetchingSMS = false;
        state.isSuccessSmsIdentify = true;
      })
      .addCase(changeBsfmProfileFlag.pending, (state) => {
        state.isFetchingSMS = true;
      })
      .addCase(changeBsfmProfileFlag.rejected, (state, action) => {
        state.isFetchingSMS = false;
        state.isErrorSmsIdentify = true;
        state.isErrorMessageSmsIdentify = action.payload
          ? action.payload.message
          : "Internal error";
      })

      .addCase(updateApplyFirewall.fulfilled, (state, action) => {
        state.isSuccessFirewall = true;
        state.updateApplyFirewallData = action.payload.data;
        state.isErrorFirewall = false;
      })
      .addCase(updateApplyFirewall.pending, (state) => {
        state.isFetchingFirewall = true;
        state.isSuccessFirewall = false;
        state.isErrorFirewall = false;
      })
      .addCase(updateApplyFirewall.rejected, (state, action) => {
        state.isFetchingFirewall = false;
        state.isSuccessFirewall = false;
        state.updateApplyFirewallData = [];
        state.isErrorFirewall = true;
      })
      .addCase(getCountryOperatorMap.fulfilled, (state, action) => {
        state.countryOperatorMap = action.payload.data;
        state.isFetchingCountryOperatorMap = false;
      })
      .addCase(getCountryOperatorMap.pending, (state) => {
        state.isFetchingCountryOperatorMap = true;
      })
      .addCase(getCountryOperatorMap.rejected, (state, action) => {
        state.countryOperatorMap = {};
        state.isFetchingCountryOperatorMap = false;
      });
  },
});

export const {
  clearStateBsfm,
  clearStateCreateBsfm,
  clearStateDeleteBsfm,
  clearStateEditBsfm,
} = bsfmSlice.actions;

export function clearState() {
  return async (dispatch) => {
    dispatch(clearStateBsfm());
  };
}

export function clearStateCreate() {
  return async (dispatch) => {
    dispatch(clearStateCreateBsfm());
  };
}

export function clearStateDelete() {
  return async (dispatch) => {
    dispatch(clearStateDeleteBsfm());
  };
}

export function clearStateEdit() {
  return async (dispatch) => {
    dispatch(clearStateEditBsfm());
  };
}

export const bsfmSelector = (state) => state.bsfm;

export default bsfmSlice.reducer;
